import { Outlet } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import React, { ReactElement } from 'react';

const LoginsContainer = (): ReactElement => {
  return (
    <AsyncPageContainer isLoading={false}>
      <Outlet />
    </AsyncPageContainer>
  );
};

export default LoginsContainer;
